export default {
  items: state => state.items,
  itemsOptions: (state) => {
    return state.items.map(function (i) {
      return { value: i, text: `${i.description} - ${i.itemModel}` };
    });
  },
  itemsBundles: state => state.itemBundle
}
